import {
  XeroAccountMappingDTO,
  XeroAccountMappingOptionListDTO,
  XeroAccountMappingPatchDTO,
  XeroAuthPageDTO,
  XeroTenantStatusDTO,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type XeroApiType = ReturnType<typeof xeroApi>;
const xeroApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    getIntegrationStatus() {
      return axiosInstance.get<XeroTenantStatusDTO>(`${clubPrefix}xero/tenant`);
    },
    enableIntegration() {
      return axiosInstance.post(`${clubPrefix}xero/tenant`);
    },
    disableIntegration() {
      return axiosInstance.delete(`${clubPrefix}xero/tenant`);
    },
    getRedirectUrlToAuthPage({ appUrl }: { appUrl: string }) {
      return axiosInstance.get<XeroAuthPageDTO>(`${clubPrefix}xero/auth`, {
        params: {
          appUrl,
        },
      });
    },
    getAccountMapping() {
      return axiosInstance.get<XeroAccountMappingDTO>(
        `${clubPrefix}xero/account-mapping`,
      );
    },
    updateAccountMapping(opts: XeroAccountMappingPatchDTO) {
      return axiosInstance.patch(`${clubPrefix}xero/account-mapping`, opts);
    },
    getAccountMappingOptionList() {
      return axiosInstance.get<XeroAccountMappingOptionListDTO>(
        `${clubPrefix}xero/account-mapping/option-list`,
      );
    },
  };
};

export default xeroApi;
